// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__JAKOb","review":"Reviews_review__AVfqX"};